module.exports = __webpack_public_path__ + "static/media/ff01.222c44fd.png";